import * as React from "react"
import { Link } from "gatsby"

import logo_reverse from "../images/icon-reverse-2.png"

const Footer = () => {
  return (
    <footer id="foot" className="bg-gray-900 text-white">
      <div className="overlay overlay-opacity-75 py-4">
        <div className="container">
          <div className="row">
            <div className="col order-2 order-lg-1">
              <p className="small m-0 d-none d-md-block">Copyright © Gala Software SrlS. All rights reserved.</p>
            </div>
            <div className="col-12 col-md-3 order-1 order-lg-2 text-end">
              <a href="#!" className="text-gray-500 d-inline-grid gap-auto-3 text-white text-decoration-none" data-scrollto="{&quot;offsetTop&quot;:0}">
                <span className="w-100">Top</span>{/* Go to top */}
                <svg className="transform-flip-x-rtl" height="18px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
                  <path fillRule="evenodd" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11.5z" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="container pb-4">
        <div className="row">
          <div className="col-12 col-sm-6 col-lg-4 py-5 small">
            <h4 className="h5 mb-4 fw-normal">Contattaci</h4>
            <p>&nbsp;</p>
            <div className="d-flex align-items-start my-3">
              <svg className="me-3 flex-none my-1" height="24px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                <circle cx={12} cy={10} r={3} />
              </svg>
              <ul className="list-unstyled p-0 m-0 w-100">
                <li><a className="text-white text-dashed" target="_blank" rel="noreferrer" href="https://www.google.com/maps?ll=46.470236,11.324554&z=16&t=m&hl=it-IT&gl=US&mapclient=embed&q=Via+Marie+Curie,+11+39100+Bolzano+BZ+Italia">Via Marie Curie , 11</a></li>
                <li>39100, Bolzano/Bozen, Italia</li>
              </ul>
            </div>
            <div className="d-flex align-items-start my-3">
              <svg className="me-3 flex-none my-1" height="24px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
              </svg>
              <ul className="list-unstyled p-0 m-0 w-100">
                <li>Phone: <a href="tel:+3904711800198" className="text-white text-dashed">+39 0471 1800198</a></li>
                <li>Email: <a href="mailto:info@galasoftware.it" className="text-white text-dashed">info@galasoftware.it</a></li>
              </ul>
            </div>
          </div>
          <div className="col overlay overlay-opacity-75 rounded-bottom overflow-hidden py-4 d-none d-lg-flex flex-column align-items-center justify-content-center">
            <img width={200} className src={logo_reverse} alt="..." />
            <h4 className="fw-normal">GALASOFTWARE SRLS</h4>
            <h7 className="fw-normal">P.I. IT 02892050218</h7>
          </div>
          <div className="col-12 col-sm-6 col-lg-4 py-5">
            <div className="row">
              <div className="col-2">
                &nbsp;
              </div>
              <div className="col-10 px-4 text-end">
                <h4 className="h5 mb-4 fw-normal text-gray-500">Resources</h4>
                <ul className="nav flex-column">
                  <li className="nav-item"><Link className="nav-link px-0" to="/">Home</Link></li>
                  {/*<li className="nav-item"><Link className="nav-link px-0" to="/services">Servizi</Link></li>*/}
                  <li className="nav-item"><Link className="nav-link px-0" to="/gs-access">GS-Access</Link></li>
                  <li className="nav-item"><Link className="nav-link px-0" to="/privacy">Informativa sulla privacy</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
